// src/langurage/zh.js
// 定义中文语言包对象
export default {
  // 导航
  navigateBar: {
    homePage: "首页",
    productDisplay: "产品展示",
    marketingNetwork: "营销网络",
    technicalService: "技术服务",
    humanResources: "人力资源",
    newsAndTrends: "资讯动态",
    aboutTengda: "关于腾达",
    investorRelations: "投资者关系",
    standardQuery: "标准查询",
    onlineMessage: "在线留言",
    tengdaYougou: "腾达优购",
    nextOne:'点击按钮切换下一个',
    seeMore:'查看更多'
  },
  // 人力资源
  humanResources: {
    talentConcept: "人才理念",
    campusRecruitment: "校园招聘",
    socialRecruitment: "社会招聘",
    rlcontent: {
      title: "人力资源",
      subtitle: "人才理念",
    },
    xycontent: {
      title: "校园招聘",
      cultivationMethod: "培养方式",
    },
    concept: {
      realization: "用好现有人才，实现最大价值",
      realizationContent:
        "通过建立健全的员工激励机制，包括薪酬、福利、晋升通道等，激励员工积极进取，创造更多的价值。",
      holdstill: "稳住关键人才，确保团队稳定",
      holdstillContent:
        "关键人才是团队稳定运行的中流砥柱，建立企业发展人才库。根据关键人才的个性化需求，制定特别的激励计划，优先参与培训和通道晋升。",
      quote: "引用急需人才，确保人岗匹配",
      quoteContent:
        "根据公司阶段发展需求，明确急需人才的需求和特点，通过猎头招聘、人才推荐等多渠道进行引进，为公司可持续发展提供有力支撑。",
      importance: "重视人才储备，建立人才梯队",
      importanceContent:
        "通过校园招聘、高校合作为组织的未来发展储备人才资源。同时，通过员工轮岗、多样化培训和多通道晋升管理，培育、储备、锻炼人才，为企业的长远发展打下人才基础。",
      train: "员工培训",
      trainContent:
        "公司注重人才培养，建立完善的员工培训机制，坚持以“内部培养为主，外部培养为辅”的原则，内部设有各专业讲师，外部与高校及培训结构合作，有计划安排讲师入企培训或员工外出培训。通过多样化的培训帮助员工更好地提升工作能力和个人素养。",
      excitation: "员工激励",
      excitationContent:
        "公司具有完善的晋升机制，针对不同岗位设立四大晋升通道，为员工发展提供方向，不断激发员工工作的积极性和主动性；设立企业人才库，关键岗位人员纳入企业人才库，进行重点培养，优先参与选拔；对于表现突出或新入职大学生人员发放人才补贴，实施轮岗培养，使其尽快成长为骨干力量。",
      welfare: "员工福利",
      welfareContent:
        "企业坚持以人为本，尊重关爱员工，广纳员工意见和建议；公司提供良好的办公环境，舒适的员工宿舍，整洁的员工餐厅；建有员工文体活动中心，定期开展丰富多彩的文娱活动，不断提升员工的归属感和凝聚力。",
    },
    school: {
      position1: "行政类管培生",
      majorRequirements1:
        "学习财务管理、审计、统计学、物流管理、供应链管理等专业",
      position2: "技术类管培生",
      majorRequirements2:
        "金属材料工程、材料成型与工程、机械设计及其自动化等机械相关专业",
      position3: "营销类管培生",
      majorRequirements3:
        "市场营销、国际经济与贸易、电子商务、商务英语、日语、韩语、越南语、德语等专业，热爱销售工作(小语种专业主要从事海外市场开发)",
      trainingMethods: "培养方式",
      trainingMethodsContent:
        "根据公司校园招聘及培养方案要求进入各岗位进行实习，了解企业产品、企业文化，轮岗实习结束后进行定岗定向培养！",
      jobRequirements: "岗位要求",
      jobRequirementsContent1:
        " 1、具有良好的共同协调能力，分析能力，快速学习能力，有较强的责任心和进取心",
      jobRequirementsContent2: " 2、工作严谨、细致、认真、责任心强，学习能力强",
      jobRequirementsContent3: " 3、具有良好的团队意识和沟通表达能力",
      applyJob: "申请职位",
    },
  },
  // 资讯动态
  newsAndTrends: {
    enterpriseNews: "企业动态",
    informationDisclosure: "信息公示",
  },
  // 关于腾达
  aboutTengda: {
    companyProfile: "公司简介",
    developmentHistory: "发展历程",
    corporateCulture: "企业文化",
  },
  // 首页
  indexContent: {
    productDisplay: "产品展示",
    enterpriseNews: "企业动态",
    productPromotion: "企业宣传",
    idea: "同创伟业 共享腾达",
  },
  // 底部
  footer: {
    contactUs: "联系我们",
    address: "地址：山东省枣庄市滕州市经济开发区鲁班大道北路1999号",
    email: "邮箱：north@tdfastener.com / marketing@tdfastener.com",
    tel: "电话：0632-5677918 / 0632-5800288",
    fax: "传真：0632-5677919 / 0632-5088827",
    electronicSampleBooklet: "电子样册",
    tengdaYougou: "腾达优购",
    idea: "同创伟业 共享腾达",
    aboutTengda: "关于腾达",
    productDisplay: "产品展示",
    salesNetwork: "销售网络",
    technicalService: "技术服务",
    onlineMessage: "在线留言",
    tengdaYougou: "腾达优购",
    company: "山东腾达紧固科技股份有限公司",
    technicalSupport: "技术支持",
    lu: " 鲁ICP备17021460号-3",
  },
  // 营销网络
  marketingNetwork: {
    first:
      "公司拥有完善的营销网络，以满足各大区域的不同需求并以优质、快捷的服务将产品提供给客户。",
    second:
      "以全面的创新体系为基础，腾达科技大力实施品牌战略，成功加入跨国公司的国际供应链，建立了坚实的客户基础和完善的营销服务网络，与国际知名企业青山钢铁、福建吴航、德国WASI GmbH、意大利Inox MareS.r.l.等建立了战略合作伙伴关系，产品远销日本、韩国、澳大利亚、印度、西班牙、德国等40多个国家和地区，已成为亚洲质量佳、品种全、上规模的不锈钢紧固件产销基地。",
    city: {
      TJ: "天津",
      TZ: "滕州",
      DN: "戴南",
      CD: "成都",
      WH: "武汉",
      DG: "台山",
    },
    marketing: "国外营销服务",
    tel: "电话",
    fax: "传真",
    email: "邮箱",
  },
  // 技术服务
  technicalService: {
    "enterpriseR&D": "企业研发",
    "enterpriseR&DContent1":
      "公司自成立以来，始终把技术创新作为企业的核心竞争力，设有专业的紧固件技术研发团队和科研平台，是省级科研平台依托单位，配备拉力试验机、光谱分析仪、金相显微镜等高端专业检测仪器，与北京科技大学、山东科技大学等高等院校和科研机构建立了产学研合作关系，不断提升公司的技术实力。",
    "enterpriseR&DContent2":
      "公司专注于汽车、核电、轨道交通和电子通讯等高端制造业高性能不锈钢紧固件产品开发，重点进行耐腐蚀性、耐高、低温、良好的机械性能等技术的研究。",
    technologicalAchievements: "技术成果",
    technologicalAchievementsContent:
      "近年来，自主开发了耐海水腐蚀、定位性能好的海底电缆用定位螺栓；防松、高强度、大面积稳固连接的不锈钢四方焊接螺母；良好的机械性能的螺纹防松法兰螺母；定位精度高、高强度以及密封性好的汽车发动机高压油轨用不锈钢定位螺母以及不锈钢六角头木螺钉以及核电用的各类标准/非标准耐高温、高压螺栓、螺母，以及汽车、高铁领域部分要求高稳定性能的专用部件的等技术。",
    product: "产品应用",
    productContent:
      "凭借雄厚的技术实力和立体化的营销网络腾达紧固件产品广泛应用于汽车、铁路、建筑、石油化工、机械制造、核能、电子设备、电力、建筑外墙、海洋工程等行业和领域。",
    enterpriseCertification: "企业认证",
    testingEquipment: "检测设备",
  },
  // 产品
  productInfo: {
    material: "材质",
    standard: "标准",
    specifications: "规格",
    headLabel: "头标",
    packagingMethod: "包装方式",
    detailedDescription: "详细描述",
  },
  // 公司简介
  companyProfile: {
    title:'公司简介',
    info:'山东腾达紧固科技股份有限公司成立于2015年，位于滕州市经济开发区鲁班大道北路1999号，占地136965平方米。公司主营紧固件、汽车零部件、金属制品及其加工等业务，采用自主研发创新工艺，生产标准及非标准紧固件产品规格多达上万种，产品广泛应用于高铁、核电、通讯、新能源、机械设备、石油化工等领域，是中核集团合格供应商，中国石化行业百佳供应商。',
    expert: "紧固件制造专家",
    expertContent:
      "山东腾达紧固科技股份有限公司成立于2015年，注册资本金20000万元，下辖4家全资子公司和其他控股子公司，公司主营各类不锈钢、特种合金紧固件产品，设计年产能14万余吨，产品被广泛应用于高铁、核电、新能源、机械装备、石油化工、海洋工程等领域，产品市场占有率连续多年位居同行业前列，是第八批（国家）制造业单项冠军、中国海关AEO高级认证企业和中国外贸出口先导指数样本企业。2024年1月19日公司成功在深交所主板登陆上市，股票代码：001379。",
    center1: "省级科研平台依托单位",
    center2:'腾达牌不锈钢紧固件被评为山东省优质品牌产品',
    centerContent:
      "公司十分注重技术创新，拥有专业的技术研发团队，是省级科研平台依托单位。目前拥有专利三十余项，其中发明专利11项，公司还参与了《核电厂用紧固件第3部分:不锈钢螺栓、螺钉和螺柱》等4项国家标准的制定，取得了3项智能制造相关软件著作权。公司坚持全面质量管理的理念，以“全员参与 、质量至上、顾客满意、追求卓越”为指导方针，先后通过了GB/T19001/24001/45001管理体系的认证、IATF16949认证、德国莱茵PED/AD2000认证、欧盟CE认证和CNAS实验室（国家级检测中心）认证、海关AEO高级认证等专业认证，腾达牌不锈钢紧固件被评为山东省优质品牌产品",
    management1: "规模化扩张到精细化管理",
    management2: "向高端客户需求迈进的成功转型",
    managementContent:
      "近年来，公司实现了从规模化扩张到精细化管理和向高端客户需求迈进的成功转型。生产运营方面，公司先后引入企业ERP、生产现场MES管理系统、智能立体仓储系统等信息化手段，全程覆盖企业管理、研发、销售、生产、仓储、品控、人力资源以及物流等业务流程，通过数据采集、流程管控和数据预警分析，实现以供应链为中心的生产、管理、销售一体化的全面信息化，提高公司整体运营效率，强化市场竞争优势。供应链合作方面，公司与核电、汽车、石油化工等行业企业进行着广泛深入的合作，建立了坚实供应链基础和完善的营销服务网络，同时与国内外知名企业青山钢铁、福建吴航、WURTHGROUP、SCHAFER+ PETERSGMBH等建立了长期稳定的合作关系。",
    lastContent:"山东腾达紧固科技股份有限公司将以先进科学的管理理念，灵活有效的经营机制，持续不断的技术创新，努力发挥行业优势，致力成为“成为世界上著名的不锈钢紧固件制造商、销售集成商和特殊行业紧固件技术解决方案提供商”，在此诚邀社会各界朋友，与腾达科技一起“同创伟业，共享腾达”！"
    },
  developmentHistory: {
    y15:'2015年',
    y1617:'2016-2017年',
    y1819:'2018-2019年',
    y2021:'2020-2021年',
    y2223:'2022-2023年',
    y24:'2024年',
    y2526:'2025-2026年',
    honors:'企业荣誉',
    2015: "2015年12月  山东腾达紧固科技股份有限公司成立",
    201601: "2016年04月  公司通过ISO9001、ISO14001、ISO45004管理体系认证。",
    202602:
      "2016年05月 与北京科技大学工程技术研究院签署产学研合作协议，就技术创新、人才培养等多方面工作开展合作",
    201603: "2016年10月 被评为“中核集团合格供应商”",
    201604: "2016年11月 首次通过国家CNAS检测实验室认证",
    201605: "2017年09月 公司首次PED/AD 2000（压力容器产品）认证",
    201606:
      "2017年12月 公司研发机构被评为枣庄市市级企业技术中心、枣庄市工程实验室",
    201607: "2017年12月  设立全资子公司-山东腾达紧固件技术开发有限公司，围绕特殊用途紧固件及特定行业紧固技术解决方案深入布局",
    201803:
      "2018年03月 公司研发的耐高温法兰螺母、发动机高压油轨专用螺帽等新产品被评委中机零协紧固件行业自主创新优秀新产品特等奖",
    201804:
      "2018年04月 公司首次通过IATF 16949 认证",
    201807:
      "2018年07月 公司“年产7.2万吨不锈钢紧固件生产项目”入选山东省省级新旧动能转换重点项目，2019年04月，入选国家重大项目储备库储备项目2019年07月该项目投产，原山东省委书记刘家义参观并现场指导工作",
    20181201: "2018年12月 公司获评山东省制造业单项冠军示范企业（产品）",
    20181202: "2018年12月/2019年12月 公司连续2年荣获中国石化行业百佳供应商荣誉",
    201905:
      "2019年05月 公司同山东科技大学签署产学研合作协议，针对技术创新、人才培养等多方向开展合作",
    201910: "2019年10月 公司举行新厂区落成庆典",
    201911:
      "2019年11月 公司“基于5G专网的紧固件行业设备数据大脑”项目入选山东省5G试点示范项目（企业）",
    20200401:
      "2020年04月 公司“不锈钢紧固件智能制造互联平台”项目入选山东省第二批“现代优势产业集群+人工智能”试点示范项目（企业）”",
    20200402: "2020年04月 公司通过欧盟CE EN 15048-1认证",
    20200501:'2020年05月  设立全资子公司-山东腾龙进出口有限公司，深度服务母公司进出口贸易业务',
    202005:
      "2020年05月 公司研发的核电用耐高温高强度连接螺栓、高铁用刚性接触网悬挂支架矩形调节螺母等新产品再次被评为中机零协紧固件行业自主创新优秀新产品特等奖",
    202006: "2020年06月 公司获批山东省“省级工程实验室”",
    202007: "2020年07月 公司获批枣庄市首批“双千工程”技术改造示范企业",
    202010: "2020年10月 公司获批山东省“省级企业技术中心”",
    202011: "2020年11月 公司主营产品“不锈钢紧固件”被评为山东省优质品牌（产品）",
    202012:
      "2020年12月 公司向中国证券监督管理委员会山东监管局正式提请开展上市辅导工作",
    202101: "2021年01月 公司被评为枣庄市智能制造试点示范企业",
    202108: "2021年08月 公司通过山东省制造业单项冠军示范企业（产品）复审",
    202110:
      "2021年10月 公司通过中国海关AEO高级认证企业复审，全资子公司山东腾龙进出口有限公司首次通过中国海关AEO高级认证企业认证",
    202112:
      "2021年12月 公司被评为枣庄市高端装备（金属制品）产业发展联盟-链主企业",
    202203:
      "2022年03月 设立全资子公司-腾达紧固科技（江苏）有限公司，布局戴南生产基地",

    202206:
      "2022年06月 中国证监会正式受理公司上市申报材料，拟在深圳证券交易所-主板上市",

    202208:
      "2022年08月 公司“基于5G专网的紧固件行业数字化车间”被评为山东省数字化车间",

    202304:
      "2023年04月 公司被评为枣庄市晨星工厂、山东省数字经济晨星工厂入库培育企业",

    202306:
      "2023年06月 公司正式通过深交所2023年第46次上市审核委员会会议审核，判定公司符合发行条件、上市条件和信息披露要求",

    202310:
      "2023年10月 公司“智能制造”生产场景被评为2023年度（国家）智能制造优秀场景",

    202311:
      "2023年11月 中国证监会正式同意公司首次公开发行股票的注册申请，公布了2023年9月12日核发的《关于同意山东腾达紧固科技股份有限公司首次公开发行股票注册的批复》（证监许可[2023]2128号）",
    202401: "2024年01月 公司在深证证券交易所主板挂牌上市",
    202403: "2024年03月 公司入选“第八批制造业单项冠军企业公示名单”",
    202407:'2024年07月  山东省支柱型雁阵集群（枣庄智能制造产业集群）头雁企业',
    202410:"2024年10月  枣庄市综合百强企业、工业百强企业",
    202411:'2024年11月  设立控股子公司-腾达晋元(安徽)紧固件有限公司，深度发展机螺钉等细分产品',
    20241101:'2024年11月   设立参股子公司-腾达虎克防松紧固件(江苏)有限公司，深度发展防松铆钉等细分产品',
    202505: "2025年05月  设立控股子公司-山东腾达友嘉机械零部件有限公司，布局机械零部件行业",
    202509: "2025年09月  公司产品被评为“山东制造·齐鲁精品”",
    202601: "2026年01月  公司收购越南耀普新材料有限公司，正式实施越南海外基地年产1.8万吨不锈钢紧固件生产项目",
    202608: "2026年08月  设立全资子公司-腾达科技（泰国）有限公司，正式实施泰国海外基地年产2310万件机械零部件生产项目"
  },
  onlineMessage:{
    name:'客户名称',
    contact:'联系方式',
    email:'电子邮件',
    content:'留言内容',
    submit:'提交',
    reset:'重置'
  },
  corporateCulture:{
    title:'企业文化',
    name1:'核心价值观',
    text1:'同创伟业 共享腾达',
    name2:'经营理念',
    text2:'诚信 创新 品质 服务',
    name3:'管理理念',
    text3:'责任 规范 行动 习惯',
    name4:'人才理念',
    text4:'用好现有人才，稳住关键人才，吸引急需人才，储备未来人才',
    name5:'质量方针',
    text5:'全员参与 质量至上 顾客满意 追求卓越',
    name6:'企业愿景',
    text6:"成为世界上著名的不锈钢紧固件制造商、销售集成商和特殊行业紧固件技术解决方案提供商",
  },
  public:{
    more:'更多',
    nextPage:'下一页'
  }
};
